import React from "react"

import { useStaticQuery, graphql } from "gatsby"
const test = () => {
  console.log("test")
}
const StoriesCategory = ({ test, storiLink }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            storiesCategory {
              item {
                name
              }
            }
            storiesCountry {
              item {
                name
                list {
                  name
                }
              }
            }
            stories {
              item {
                name
                date
                country
                mainPhoto
                title
                smallDescription
                stories
                link
                tags
                id
              }
            }
          }
        }
      }
    `
  )
  //   let filterArray =
  //     site.siteMetadata &&
  //     site.siteMetadata.norwayItems.map(items => items.item.status.season)
  //   let uniqueArray = filterArray.filter(function(item, pos) {
  //     return filterArray.indexOf(item) == pos
  //   })

  console.log("SITE META", site.siteMetadata)
  return (
    site.siteMetadata &&
    site.siteMetadata.storiesCountry.map((item, index) => {
      return (
        <div className="box" key={index}>
          <h3>{item.item.name}</h3>
          <ul>
            {console.log("EEEEEEEEE", item)}
            {item &&
              item.item &&
              item.item.list &&
              item.item.list.map((name, index) => {
                return (
                  <li
                    key={index}  
                  >
                    {storiLink ? <a href="/stories">{name.name}</a> : null }
                    {!storiLink ? <span onClick={() => test(site.siteMetadata, name.name)} >{name.name}</span> : null }
                  </li>
                )
              })}
          </ul>
        </div>
      )
    })
    // <ul>
    //   {/* <li>
    //     <a href="/">All Stories</a>
    //   </li> */}
    //   {site.siteMetadata &&
    //     site.siteMetadata.storiesCategory.map((item, index) => {
    //       return (
    //         <li key={index} onClick={() => test(site.siteMetadata, item)}>
    //           {item.item.name}
    //         </li>
    //       )
    //     })}
    // </ul>
  )
}

export default StoriesCategory
